import { createFileRoute } from "@tanstack/react-router";
import { protectedLeaf } from "../../../router/route-contracts";
import ProjectReportDocument from "../../../views/projects/report/ProjectReportDocument";

export const Route = createFileRoute("/_protected/project-reports/$projectId")({
  component: ProjectReportDocument,
  staticData: protectedLeaf({
    requiredRoles: [],
    routeKey: "project-report",
    access: "protected",
    layout: "blank",
    container: "gutterless",
    footer: false,
  }),
});
